/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 4/12/16.
 */
'use strict';

function AssetInfoModalController(_, SystemMediainfoResource, EndPointService, AuthFactory) {
    const getProxyContent = () => {
        return `${EndPointService.mediaAssetEndpoint}` +
            `?contentId=${this.resolve.asset.proxyId}` +
            `&${AuthFactory.getAuthQueryString()}`;
    };

    const getSourceContent = () => {
        return `${EndPointService.mediaAssetEndpoint}` +
            `?assetId=${this.resolve.asset.assetId}` +
            `&contentUse=SOURCE` +
            `&${AuthFactory.getAuthQueryString()}`;
    };

    this.assetType = this.resolve.assetType;

    const getAssetAcceptProfile = () => {
        return (
            _.get(this, 'resolve.asset.acceptProfile') ||
            _.get(this, 'resolve.asset.videoAcceptProfile') ||
            _.get(this, 'resolve.asset.mediaAcceptProfile')
        );
    };

    this.hasSource = () => {
        const acceptProfileType = _.get(this, 'resolve.asset.acceptProfile.type');
        return !acceptProfileType || acceptProfileType.toLowerCase() !== 'video';
    };

    this.hasProxy = () => {
        return !this.hasSource();
    };

    this.downloadAsset = () => {
        if (_.includes(['video', 'image', 'other'], getAssetAcceptProfile().type.toLowerCase())) {
            let path;
            if (this.hasSource()) {
                path = getSourceContent();
            } else {
                path = getProxyContent();
            }
            window.open(path);
        }
        this.dismiss({$value: 'cancel'});
    };

    this.$onInit = () => {
        this.mediaInfo = SystemMediainfoResource.get({id: this.resolve.asset.assetId});
    };
}

angular.module('prism-ui.components').component('assetInfoModal', {
    templateUrl: 'package/editor/components/view/preview/modals/assetInfoModal/asset-info-modal-template.html',
    controller: AssetInfoModalController,
    bindings: {
        resolve: '<',
        dismiss: '&'
    }
});
